/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AdvancedSettingsV4_organization$ref = any;
export type MigrationStatus = "COMPLETED" | "ERROR" | "NONE" | "REQUESTED" | "RUNNING";
import type { FragmentReference } from "relay-runtime";
declare export opaque type V4ConstitutionSection_organization$ref: FragmentReference;
declare export opaque type V4ConstitutionSection_organization$fragmentType: V4ConstitutionSection_organization$ref;
export type V4ConstitutionSection_organization = {|
  +id: string,
  +name: string,
  +v5migrationStatus: MigrationStatus,
  +setupModeEnabled: boolean,
  +viewer: {|
    +routes: {|
      +constitutionUrl: string
    |}
  |},
  +$fragmentRefs: AdvancedSettingsV4_organization$ref,
  +$refType: V4ConstitutionSection_organization$ref,
|};
export type V4ConstitutionSection_organization$data = V4ConstitutionSection_organization;
export type V4ConstitutionSection_organization$key = {
  +$data?: V4ConstitutionSection_organization$data,
  +$fragmentRefs: V4ConstitutionSection_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "V4ConstitutionSection_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "v5migrationStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "setupModeEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Routes",
          "kind": "LinkedField",
          "name": "routes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "constitutionUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AdvancedSettingsV4_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '2661cc04bcb96f800600fcdfbbb71099';

module.exports = node;
